import { atom } from "jotai";
import { StudyWriterConfig } from "../types/IStudyWriterConfig";

export const studyWriterConfigAtom = atom<StudyWriterConfig | null>(null);
